import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html } from "lit";
import { localized, msg } from "@lit/localize";
import { property, query } from "lit/decorators.js";
import "@progressive-development/pd-forms/pd-button";
import "@progressive-development/pd-forms/pd-form-container";
import "@progressive-development/pd-forms/pd-form-row";
import "@progressive-development/pd-forms/pd-input";
import "@progressive-development/pd-forms/pd-input-area";
import "@progressive-development/pd-composite/pd-contact";
import { pdIcons } from "@progressive-development/pd-icon";
//#region src/pd-contact-us/PdContactUs.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var PdContactUs = class PdContactUs extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.contact = {};
	}
	static {
		this.styles = [css`
      :host {
        display: block;
        background-color: var(--pd-contactus-bg-col, var(--pd-default-col));
        background-image: var(--pd-contactus-bg-image);
        background-repeat: no-repeat;
        width: 100%;
      }

      .contact-layout {
        display: flex;
        flex-wrap: wrap;
        gap: 2rem;
        align-items: flex-start;
      }

      .contact-card {
        flex: 1 1 300px;
        min-width: 280px;
        max-width: 420px;
        /* Forward --pd-contactus-font-col to pd-contact internals */
        --pd-contact-address-col: var(
          --pd-contactus-font-col,
          var(--pd-default-bg-col)
        );
        --pd-contact-address-title-col: var(
          --pd-contactus-font-col,
          var(--pd-default-bg-col)
        );
        --pd-default-font-content-col: var(
          --pd-contactus-font-col,
          var(--pd-default-bg-col)
        );
        --pd-default-font-title-col: var(
          --pd-contactus-font-col,
          var(--pd-default-bg-col)
        );
        --pd-contact-icon-col: var(
          --pd-contactus-font-col,
          var(--pd-default-bg-col)
        );
      }

      .contact-form {
        flex: 1 1 360px;
        min-width: 300px;
        max-width: 520px;
      }
    `];
	}
	render() {
		return html`
      <div class="contact-layout">
        <div class="contact-card">
          <pd-contact .contact="${this.contact}" summary></pd-contact>
        </div>

        <div class="contact-form">
          <pd-form-container id="contactFormId">
            <pd-form-row>
              <pd-input
                id="nameInputId"
                minlength="3"
                maxlength="100"
                placeHolder="${msg("Name", { id: "pd.contactus.address.name" })}"
                valueName="name"
                autoCompleteName="full-name"
                required
              ></pd-input>
            </pd-form-row>

            <pd-form-row>
              <pd-input
                id="mailInputId"
                placeHolder="${msg("Email", { id: "pd.contactus.address.email" })}"
                valueName="email"
                autoCompleteName="email"
                name="email"
                fieldType="mail"
                required
              ></pd-input>
            </pd-form-row>

            <pd-form-row>
              <pd-input
                id="phoneInputId"
                placeHolder="${msg("Telefon", { id: "pd.contactus.address.phone" })}"
                valueName="phone"
                fieldType="phone"
                autoCompleteName="tel"
                required
              ></pd-input>
            </pd-form-row>

            <pd-form-row>
              <pd-input-area
                id="msgInputId"
                minlength="6"
                maxlength="500"
                placeHolder="${msg("Nachricht", { id: "pd.contactus.address.message" })}"
                rows="8"
                required
                valueName="msg1"
              ></pd-input-area>
            </pd-form-row>

            <pd-form-row>
              <pd-button
                icon="${pdIcons.ICON_MAIL}"
                text="${msg("Absenden", { id: "pd.contactus.address.send" })}"
                @button-clicked="${this._sendMail}"
                primary
              ></pd-button>
            </pd-form-row>
          </pd-form-container>
        </div>
      </div>
    `;
	}
	clear() {
		this._form?.clear();
	}
	_sendMail() {
		this._form.triggerValidate().then((result) => {
			if (result) {
				this.dispatchEvent(new CustomEvent("send-contact-request", { detail: { msgObj: this._form.getValues().origin } }));
				this._form.reset();
			}
		});
	}
};
__decorate([property({ type: Object })], PdContactUs.prototype, "contact", void 0);
__decorate([query("#contactFormId")], PdContactUs.prototype, "_form", void 0);
PdContactUs = __decorate([localized()], PdContactUs);
//#endregion
export { PdContactUs };
